"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScript = exports.ensureScript = void 0;
const loaded = [];
function ensureScript(url) {
    if (loaded.includes(url))
        return Promise.resolve();
    loaded.push(url);
    return loadScript(url);
}
exports.ensureScript = ensureScript;
function loadScript(url) {
    // todo make sure this works universally for all browsers
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => {
            console.log('Loaded', url);
            resolve();
        };
        script.onerror = () => {
            console.warn('failed to load', url);
            reject();
        };
        script.type = 'text/javascript';
        document.body.appendChild(script);
    });
}
exports.loadScript = loadScript;
